import script from "./ConnectedNumbersNarrowTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ConnectedNumbersNarrowTable.vue?vue&type=script&setup=true&lang=js"

import "./ConnectedNumbersNarrowTable.vue?vue&type=style&index=0&id=4e730fc8&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e730fc8"]])

export default __exports__